


































































































































































































































































































import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { Country } from "@/shared/models/country";
import {
  ReservationAccUnitModel,
  ReservationCustomerModel,
  ReservationGuestModel,
  ReservationModel,
} from "./types";
import MoreLessSelect from "@/components/misc/MoreLessSelect.vue";
import CustomerLookup from "@/components/misc/CustomerLookup.vue";
import VCustomer from "@/shared/models/vCustomer";
import { CustomerModel } from "@/shared/models/vCustomer";
import FormDescription from "@/components/misc/FormDescription.vue";
import NumericPicker from "@/components/misc/NumericPicker.vue";
import { differenceInYears } from "@/shared/dateFormatUtils";
import brokenRuleAdapter from "@/shared/handleBrokenRuleAdapter";
import { AxiosResponse } from "axios";
import { Notification } from "@/store/modules/notifications";
import CheckInOutEditForm from "@/components/reservation-form/check-in/CheckInOutEditForm.vue";
import { policyChecker } from "@/shared/roles";
import { JwtClaims } from "@/store/modules/auth";
import { EVisitorIntegrationModel } from "@/shared/models/eVisitor";
import { EVisitorIntegrationEnum, EVisitorIntegrationNameEnum } from "@/shared/models/enums.type";

@Component({
  components: {
    MoreLessSelect,
    FormDescription,
    NumericPicker,
    CustomerLookup,
    CheckInOutEditForm,
  },
})
export default class ReservationFormUnitGuests extends Vue {
  @PropSync("unit", { default: undefined }) model?: ReservationAccUnitModel;
  @Prop({ default: null }) reservation?: ReservationModel;

  lookupOpen = false;
  editOpen = false;

  @Action("codebooks/refreshCountries") refreshCountries?: () => Promise<void>;
  @Getter("codebooks/countries") countries?: Country[];

  @Getter("appParams/showCopyGuestsButton")
  showCopyGuestsButton?: boolean;

  async created() {
    const promises = [];
    if ((this.countries?.length ?? 0) === 0 && this.refreshCountries) {
      promises.push(this.refreshCountries());
    }
    await Promise.all(promises);
  }

  @Getter("auth/claims") claims?: JwtClaims;

  get isOwnerLevel3() {
    return policyChecker("OWNER_LEVEL_3")(this.claims);
  }

  updateChildren() {
    if (this.model) {
      if (!this.model.numberOfChildren || this.model.numberOfChildren <= 0) {
        this.model.childrenAges = [];
        return;
      }

      while (this.model.childrenAges.length < this.model.numberOfChildren) {
        this.model.childrenAges.push(0);
      }

      while (this.model.childrenAges.length > this.model.numberOfChildren) {
        this.model.childrenAges.pop();
      }
    }
  }

  get customerLookupFilterPrefil() {
    return {
      excludeIds:
        this.reservation?.accomodationUnitTypes
          .flatMap((x) => x.guests)
          .map((x) => x.id) ?? [],
    };
  }

  @Action("reservation/setGuestsUnchanged") setGuestsUnchanged?: (
    payload: boolean
  ) => Promise<void>;
  @Getter("reservation/guestsUnchanged") guestsUnchanged?: boolean;

  selected(customers: VCustomer[] | CustomerModel[]) {
    if (this.model) {
      for (const guest of customers) {
        this.model.guests.push({
          id: guest.id,
          reservationsAccUnitTypeGuestId: 0,
          name: (guest as VCustomer).name
            ? (guest as VCustomer).name
            : (guest as CustomerModel).isLegalEntity
            ? (guest as CustomerModel).legalEntityName ?? ""
            : (guest as CustomerModel).firstName +
              " " +
              (guest as CustomerModel).lastName,
          eMail: guest.eMail || "",
          telephoneNumber: guest.telephoneNumber || "",
          countryOfResidenceId: guest.countryOfResidenceId,
          dateOfBirth: guest.dateOfBirth,
          city: guest.city,
          isLegalEntity: guest.isLegalEntity,
          identificationNumber:
            ((guest as VCustomer).name
              ? (guest as VCustomer).identificationNumber
              : (guest as CustomerModel).isLegalEntity
              ? (guest as CustomerModel).businessId
              : (guest as CustomerModel).identificationDocumentNumber) ?? "",
          isCheckedIn: false,
          isCheckedOut: false,
          isEVisitorCheckedIn: false,
          isEVisitorCheckedOut: false,
          isRoomHolder: false,
          status: true,
          menuShown: false,
        });

        this.setGuestsUnchanged && this.setGuestsUnchanged(false);
      }

      this.setFirstGuestAsRoomHolder();

      const today = new Date();
      const stringToday = today.toISOString().substring(0, 10);
      today.setFullYear(today.getFullYear() - 18);
      const stringDate18YearsAgo = today.toISOString().substring(0, 10);

      const adults = this.model.guests.filter(
        (x) =>
          !x.dateOfBirth ||
          (x.dateOfBirth as string).substring(0, 10) <= stringDate18YearsAgo
      );
      const children = this.model.guests.filter(
        (x) =>
          x.dateOfBirth &&
          (x.dateOfBirth as string).substring(0, 10) > stringDate18YearsAgo
      );

      if (this.model.numberOfAdults < adults.length)
        this.model.numberOfAdults = adults.length;
      if (this.model.numberOfChildren < children.length) {
        const skip = this.model.childrenAges.length;
        children.slice(skip).forEach((x) => {
          const age = Math.floor(
            differenceInYears(
              new Date(x.dateOfBirth as string),
              new Date(stringToday)
            )
          );
          this.model?.childrenAges.push(age);
        });
        this.model.numberOfChildren = children.length;
      }
    }
  }

  get guestDepartureTime() {
    const unitDepartureTime = this.model?.expectedDepartureTime ?? "";

    if (unitDepartureTime === "") {
      return this.model?.propertyCheckoutTimeUntil.substring(0, 5);
    }

    return unitDepartureTime;
  }

  editGuestId: number | null = null;
  editGuest(guest: ReservationGuestModel) {
    this.editGuestId = guest.reservationsAccUnitTypeGuestId;
    this.editOpen = true;
    guest.menuShown = false;
  }

  guestUpdated() {
    this.$emit("updateGuest");
    this.editOpen = false;
  }

  getGuestName(guest: ReservationCustomerModel) {
    const words = guest.name.split(" ").filter((x) => x.trim());
    let initials = "";
    words.forEach((x) => (initials += x[0].toUpperCase()));
    return initials;
  }

  getCountryOfResidence(guest: ReservationCustomerModel) {
    const country = this.countries?.find(
      (x) => x.id == guest.countryOfResidenceId
    );
    if (country) {
      return this.$t(
        `Country.Official.${country.isoThreeLetterCode}`
      ).toString();
    }

    return "";
  }

  get hasWarning() {
    if (this.model) {
      return (
        this.model.numberOfAdults + this.model.numberOfChildren >
          this.model.maxOccupancy ||
        this.model.numberOfAdults > this.model.maxNumberOfAdults
      );
    }
    return false;
  }

  get rules() {
    return {
      age: (value: number) =>
        ((!!value || value === 0) && value >= 0 && value % 1 == 0) ||
        this.$t("Reservation.ChildAgeMustBeWholePositiveNumber"),
      mustBeWholeNumber: (value: number) =>
        value == null ||
        value == undefined ||
        value % 1 == 0 ||
        this.$t("Validation.MustBeWholeNumber"),
      mustBePositive: (value: number) =>
        value == null ||
        value == undefined ||
        value >= 0 ||
        this.$t("Validation.MustBePositive"),
    };
  }

  get childrenAgesValid() {
    if (this.model) {
      const result = this.model.childrenAges.every((age) => {
        return (!!age || age === 0) && age >= 0 && age % 1 == 0;
      });

      return result;
    }

    return true;
  }
  set numberOfChildren(value: number | null) {
    if (this.model) {
      this.model.numberOfChildren = value ?? 0;
    }
  }

  get numberOfChildren() {
    return this.model?.numberOfChildren ?? 0;
  }

  set numberOfAdults(value: number | null) {
    if (this.model) {
      this.model.numberOfAdults = value ?? 0;
    }
  }

  get numberOfAdults() {
    return this.model?.numberOfAdults ?? 0;
  }

  guestStatusDescriptionTR(g: ReservationGuestModel) {
    if (g) {
      if (g.isCheckedOut) return "Reservation.Guest.CheckedOut";
      if (g.isCheckedIn) return "Reservation.Guest.CheckedIn";
    }
    return "Reservation.Guest.NotCheckedIn";
  }

  guestEVisitorStatusDescriptionTR(g: ReservationGuestModel) {
    if (g) {
      if (g.isEVisitorCheckedOut) return "Reservation.Guest.CheckedOut";
      if (g.isEVisitorCheckedIn) return "Reservation.Guest.CheckedIn";
    }
    return "Reservation.Guest.NotCheckedIn";
  }

  updateGuests(guest: ReservationGuestModel) {
    if (this.model) {
      this.model.guests.map((x) => {
        if (x.id !== guest.id) x.isRoomHolder = false;

        return x;
      });
    }
  }

  async saveGuestPlaceholder() {
    if (this.reservation?.id && this.model && this.model.id) {
      const data = {
        reservationAccUnitTypeId: this.model.id,
        guestPlaceholder: this.model.guestPlaceholder,
      };

      const result = await this.axios.put(
        "/Reservations/UpdateGuestPlaceholder",
        data
      );

      if (result.status == 200) {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("GuestPlaceholder.SaveSuccess"),
          timeout: 5000,
        });
      }
    } else {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("GuestPlaceholder.RequiresSaving"),
        timeout: 5000,
      });
    }
  }

  async deleteGuestPlaceholder() {
    if (this.reservation?.id && this.model && this.model.id) {
      const data = {
        reservationAccUnitTypeId: this.model.id,
      };

      const result = await this.axios.put(
        "/Reservations/DeleteGuestPlaceholder",
        data
      );

      if (result.status == 200) {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("GuestPlaceholder.DeleteSuccess"),
          timeout: 5000,
        });

        this.model.guestPlaceholder = null;
      }
    } else {
      if (this.model) {
        this.model.guestPlaceholder = null;
      }
    }
  }

  setFirstGuestAsRoomHolder() {
    if (
      this.model &&
      this.model?.guests.length > 0 &&
      !this.model?.guests.some((x) => x.isRoomHolder == true)
    ) {
      this.model.guests[0].isRoomHolder = true;
    }
  }

  removingGuest = false;
  removeGuest(guest: ReservationGuestModel, overrides: string[]) {
    // in case guest is not yet saved on reservation just remove them on the client
    if (this.model && guest.reservationsAccUnitTypeGuestId === 0) {
      const index = this.model.guests.findIndex((x) => x == guest);
      if (index != -1) {
        this.model.guests.splice(index, 1);
        this.setFirstGuestAsRoomHolder();
      }
    }
    // otherwise remove the guest serverside
    else {
      const handleCodes = ["Reservation.RemoveGuest.CheckedIn"];
      const adapter = brokenRuleAdapter(this.axios, handleCodes);

      // prettier-ignore
      const formatBrokenRuleNames = (x: string[]) => x
      .map((h) => this.$t(h, {eVisitorServiceName: this.eVisitorIntegrationName}).toString())
      .map((th) => th.endsWith(".") ? th : th + ".")
      .join(" ");

      const confirmOverrideNotification = (
        x: AxiosResponse & { handled: string[] }
      ) =>
        this.$store.dispatch("showNotification", {
          color: "warning",
          message: formatBrokenRuleNames(x.handled),
          timeout: 30000,
          actions: [
            {
              text: this.$t("Yes"),
              fun: () => {
                this.removeGuest(guest, x.handled);
                return true;
              },
            },
            {
              text: this.$t("Cancel"),
              fun: () => {
                this.$emit("removeGuestEnd", false);
                return true;
              },
            },
          ],
        } as Notification);

      const isOverriding = overrides.length !== 0;

      this.removingGuest = true;
      this.$emit("removeGuestStart");
      return Vue.axios
        .post(
          `/reservations/RemoveGuest`,
          {
            reservationsAccUnitTypeGuestId:
              guest.reservationsAccUnitTypeGuestId,
            overrideRules: overrides,
          },
          isOverriding ? undefined : { adapter }
        )
        .then(() => {
          this.$emit("removeGuestEnd", true);
        })
        .finally(() => {
          this.removingGuest = false;
        })
        .catch((x) => {
          if (x && x.isHandleBrokenRuleResult && !isOverriding) {
            confirmOverrideNotification(x);
          } else {
            this.$store.dispatch("showNotification", {
              color: "error",
              message: `${formatBrokenRuleNames(x.unhandled)}`,
              timeout: 5000,
            } as Notification);
          }
          this.$emit("removeGuestEnd", false);
        });
    }
  }

  unitCheckIn() {
    this.$emit("checkInUnit", this.model?.accomodationUnitId);
  }
  unitCheckOut() {
    this.$emit("checkOutUnit", this.model?.accomodationUnitId);
  }

  @Getter("appParams/tenantEVisitorIntegration")
  eVisitorIntegration?: EVisitorIntegrationModel;

  get eVisitorIntegrationName() {
    return this.eVisitorIntegration?.name ?? EVisitorIntegrationNameEnum.None;
  }
  get showEvisitor() {
    return this.eVisitorIntegration?.id !== EVisitorIntegrationEnum.None;
  }
}
